
export const signalRConnectionUrl: string = 'signalRHub'
export enum SignalRChannelType {
  SignalRChannel = 'SignalRChannel',
  BellNotification = 'BellNotification'
}
